import {
  DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST,
  CLEAR_DEPOSIT_RELATED_TSUNAMIS_DATA,
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SORT,
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_TOGGLE_COLUMN,
} from './depositRelatedTsunamisReducer';


export const clearData = () => ({ type: CLEAR_DEPOSIT_RELATED_TSUNAMIS_DATA });
export const getDeposit = ({ id }) => ({ type: DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST, id });

export const deleteTsunami = ({ id }) => ({ type: DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST, id });
export const sortTsunamis = sort => ({ type: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SORT, sort });
export const getTsunamis = ({ id }) => ({ type: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST, id });

export const getGeologicAges = () => ({ type: DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST });
export const getPublications = () => ({ type: DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST });

export const toggleTsunamiColumns = visibleColumns => ({ type: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
